import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ProductCatalogManagementComponent } from './product-catalog-management.component';
import { LampInfoCardComponent } from './components/lamp-info-card/lamp-info-card.component';
import { ProductManagementDialogComponent } from './dialog/product-management-dialog/product-management-dialog.component';
import { NgxMaskModule } from 'ngx-mask';

@NgModule({
  declarations: [ProductCatalogManagementComponent, LampInfoCardComponent, ProductManagementDialogComponent],
  imports: [CommonModule, SharedModule, NgxMaskModule.forChild()],
})
export class ProductCatalogManagementModule {}
